'use strict';

wbApp.controller('ActivityScheduleDetailCtrl', ['$scope', 'activityScheduleSvc', 
function ($scope, activityScheduleSvc) {

    // $scope.singlePeriodProgramOnly from caller

    function reloadData() {
        $scope.weeks = angular.copy($scope.activityWeeks);
        $scope.selection = [];
        for (var sw = 0; sw < $scope.selectedWeeks.length; sw++) {
            var sweek = $scope.selectedWeeks[sw];

            for (var w = 0; w < $scope.weeks.length; w++) {
                var week = $scope.weeks[w];
                if (week.weekNo === sweek.weekNo) {
                    if (moment(week.startDay).isSame(moment(sweek.startDay))) {
                        $scope.selection.push(week);
                    }
                }
            }
        }

        $scope.scheduleDetailModel = new webooker_acivity_models.ScheduleDetail($scope.selection.slice(0));
    }

    $scope.onWeekSelectionChange = function (selection) {
        $scope.scheduleDetailModel.applyChanges.call($scope.scheduleDetailModel);
        $scope.scheduleDetailModel.scheduleWeeks.length = 0;
        $scope.scheduleDetailModel.scheduleWeeks.push.apply(
            $scope.scheduleDetailModel.scheduleWeeks,
            selection);
        $scope.scheduleDetailModel.onDataSourceChange.call($scope.scheduleDetailModel);
    }

    $scope.saveActivityDetailChanges = function (scheduleDetailModel) {
        $scope.activityScheduleDetailError = null;
        $scope.scheduleDetailModel.applyChanges.call($scope.scheduleDetailModel);

        activityScheduleSvc.saveAsync(
            $scope.weeks,
            $scope.semesterID,
            $scope.activityID)
        .then(function(data) {
            $scope.onScheduleDetailSave(data);
        }, function (reason) {
            $scope.activityScheduleDetailError = reason.data;
        });
    }

    reloadData();

}]);